// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import VisTimelineController from "./vis_timeline_controller"
import FlashController from "./flash_controller"
import MentionsController from "./mentions_controller"

application.register("hello", HelloController)
application.register("vis-timeline", VisTimelineController)
application.register("flash", FlashController)
application.register("mentions", MentionsController)
